import { createClient, type SupabaseClient } from "@supabase/supabase-js";

export const url: string | undefined = import.meta.env["VITE_SUPABASE_URL"];
export const anonKey: string | undefined = import.meta.env["VITE_SUPABASE_ANON_KEY"];

/**
 * The anon key is public by design — it ships in the browser bundle and is not a secret.
 * RLS is the security boundary. service_role is the actual secret and lives only in Edge
 * Function config.
 *
 * Null when unconfigured, so the app builds and runs against sample data before a Supabase
 * project exists.
 */
export const supabase: SupabaseClient | null = url && anonKey ? createClient(url, anonKey) : null;

export const isConfigured = supabase !== null;
